export default function Burger() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="24" viewBox="0 0 50 24" fill="none">
            <rect width="50" height="4" fill="white"/>
            <rect y="10" width="50" height="4" fill="white"/>
            <rect x="12" y="20" width="38" height="4" fill="white"/>
        </svg>
    )
}